import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-7 pb-2" }
const _hoisted_3 = { class: "col-lg-5 pb-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-7 pb-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-4 pb-2" }
const _hoisted_8 = { class: "col-lg-4 pb-2" }
const _hoisted_9 = { class: "col-lg-4 pb-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-4 pb-2" }
const _hoisted_12 = { class: "col-lg-4 pb-2" }
const _hoisted_13 = { class: "col-lg-4 pb-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-4 pb-2" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-4 pb-2" }
const _hoisted_18 = { class: "col-lg-4 pb-2" }
const _hoisted_19 = { class: "col-lg-4 pb-2" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-4 pb-2" }
const _hoisted_22 = { class: "col-lg-4 pb-2" }
const _hoisted_23 = { class: "col-lg-4 pb-2" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "row pb-2" }
const _hoisted_28 = { class: "col-lg-6 pb-2" }
const _hoisted_29 = { class: "col-lg-6 pb-2" }
const _hoisted_30 = { class: "col-lg-6 pb-2" }
const _hoisted_31 = { class: "col-lg-6 pb-2" }
const _hoisted_32 = { class: "row pb-2" }
const _hoisted_33 = { class: "col-lg-6 pb-2" }
const _hoisted_34 = { class: "col-lg-6 pb-2" }

import { ref, onMounted, inject } from "vue";
import {
  accountTypes,
  accountTypesSelection,
  accountRolesSelection,
  investorDistinctionSelection,
  moneyRange,
  mainIncomeSources,
  transactionMotives,
  mainFunds,
  experienceSelections,
  investmentPurposes,
  assetManagementPeriodSelection,
  financialInstiutionTypes,
  depositTypesSelection,
} from "@/core/types/jp/verificationFinancial";

export default /*#__PURE__*/_defineComponent({
  __name: 'JpFinancial',
  setup(__props) {

const formData = inject<any>("formData");
const verificationDetails = inject<any>("verificationDetails");
const disabled = inject<any>("disabled");

const getItemByValue = (value, items) => {
  if (Array.isArray(items)) {
    return (
      items.find((item) => item.value === value) || { label: "", value: "" }
    );
  } else if (typeof items === "object") {
    return (
      Object.values(items).find((item) => item.value === value) || {
        label: "",
        value: "",
      }
    );
  }
  return {
    label: "",
    value: "",
  };
};

onMounted(() => {
  formData.value = verificationDetails.value.financial;
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.preferredTradingAccount'),
          prop: "accountTypes",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _unref(formData).accountTypes,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).accountTypes) = $event)),
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountTypesSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.accountType'),
          prop: "accountRole",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).accountRole,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).accountRole) = $event)),
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountRolesSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.investorDistinction'),
          prop: "investorDistinction"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).investorDistinction,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).investorDistinction) = $event)),
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investorDistinctionSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.annualIncome'),
          prop: "annualIncome",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).annualIncome,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).annualIncome) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: getItemByValue(_unref(formData).annualIncome, _unref(moneyRange)).value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).annualIncome, _unref(moneyRange)).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.valueOfInvestment'),
          prop: "investment",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).investment,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).investment) = $event)),
              size: "large",
              class: "row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: getItemByValue(_unref(formData).investment, _unref(moneyRange)).value,
                  disabled: _unref(disabled)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).investment, _unref(moneyRange)).label), 1)
                  ]),
                  _: 1
                }, 8, ["label", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.amountOfInvestmentFunds'),
          prop: "investmentFunds",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).investmentFunds,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).investmentFunds) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: getItemByValue(_unref(formData).investmentFunds, _unref(moneyRange)).value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).investmentFunds, _unref(moneyRange)).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.mainSourceOfIncome'),
          prop: "mainSourceOfIncome",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).mainIncomeSource,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).mainIncomeSource) = $event)),
              placeholder: _ctx.$t('fields.select'),
              class: "w-250px",
              clearable: "",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: 
              getItemByValue(_unref(formData).mainIncomeSource, _unref(mainIncomeSources)).label
            ,
                  value: 
              getItemByValue(_unref(formData).mainIncomeSource, _unref(mainIncomeSources)).value
            
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.transactionMotive'),
          prop: "transactionMotive",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).transactionMotive,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).transactionMotive) = $event)),
              placeholder: _ctx.$t('fields.select'),
              class: "w-250px",
              clearable: "",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: 
              getItemByValue(_unref(formData).transactionMotive, _unref(transactionMotives))
                .label
            ,
                  value: 
              getItemByValue(_unref(formData).transactionMotive, _unref(transactionMotives))
                .value
            
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.characteristicsOfMainFunds'),
          prop: "mainFund",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).mainFund,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).mainFund) = $event)),
              placeholder: _ctx.$t('fields.select'),
              class: "w-250px",
              clearable: "",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: getItemByValue(_unref(formData).mainFund, _unref(mainFunds)).label,
                  value: getItemByValue(_unref(formData).mainFund, _unref(mainFunds)).value
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.assetManagementPeriod'),
          prop: "assetManagementPeriod",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).assetManagementPeriod,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).assetManagementPeriod) = $event)),
              placeholder: _ctx.$t('fields.select'),
              class: "w-250px",
              clearable: "",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: 
              getItemByValue(
                _unref(formData).assetManagementPeriod,
                _unref(assetManagementPeriodSelection)
              ).label
            ,
                  value: 
              getItemByValue(
                _unref(formData).assetManagementPeriod,
                _unref(assetManagementPeriodSelection)
              ).value
            
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_form_item, {
          label: 'FX' + ' (' + _ctx.$t('fields.foreignExchangeMarginTrading') + ')',
          prop: "fx",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).fx,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).fx) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: getItemByValue(_unref(formData).fx, _unref(experienceSelections)).value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).fx, _unref(experienceSelections)).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.stockTradingSpot'),
          prop: "stockTradingSpot",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).stockTradingSpot,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).stockTradingSpot) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: 
              getItemByValue(_unref(formData).stockTradingSpot, _unref(experienceSelections))
                .value
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).stockTradingSpot, _unref(experienceSelections))
                .label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.stockTradingCredit'),
          prop: "stockTradingCredit",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).stockTradingCredit,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).stockTradingCredit) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: 
              getItemByValue(_unref(formData).stockTradingCredit, _unref(experienceSelections))
                .value
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).stockTradingCredit, _unref(experienceSelections))
                .label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.indexOption'),
          prop: "indexOption",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).indexOption,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).indexOption) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: 
              getItemByValue(_unref(formData).indexOption, _unref(experienceSelections)).value
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(_unref(formData).indexOption, _unref(experienceSelections)).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.commodityFuturesTrading'),
          prop: "commodityFuturesTrading",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).commodityFuturesTrading,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).commodityFuturesTrading) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: 
              getItemByValue(
                _unref(formData).commodityFuturesTrading,
                _unref(experienceSelections)
              ).value
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(
                _unref(formData).commodityFuturesTrading,
                _unref(experienceSelections)
              ).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.otherDerivativesTransaction'),
          prop: "otherDerivativesTransaction",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).otherDerivativesTransaction,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formData).otherDerivativesTransaction) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: 
              getItemByValue(
                _unref(formData).otherDerivativesTransaction,
                _unref(experienceSelections)
              ).value
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getItemByValue(
                _unref(formData).otherDerivativesTransaction,
                _unref(experienceSelections)
              ).label), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('fields.investmentPurposeOfFxTrading'),
        prop: "investmentPurpose",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox_group, {
            modelValue: _unref(formData).investmentPurpose,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formData).investmentPurpose) = $event)),
            size: "large",
            class: "row",
            disabled: _unref(disabled)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investmentPurposes), (v_item, index) => {
                return (_openBlock(), _createBlock(_component_el_checkbox, {
                  key: index,
                  label: v_item.value,
                  class: "col-lg-3 col-md-6 mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(v_item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.financialInstiutionName'),
          prop: "financialInstiutionName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).financialInstiutionName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formData).financialInstiutionName) = $event)),
              disabled: _unref(disabled)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.financialInstiutionType'),
          prop: "financialInstiutionType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).financialInstiutionType,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formData).financialInstiutionType) = $event)),
              placeholder: _ctx.$t('fields.select'),
              class: "w-250px",
              clearable: "",
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: 
              getItemByValue(
                _unref(formData).financialInstiutionType,
                _unref(financialInstiutionTypes)
              ).label
            ,
                  value: 
              getItemByValue(
                _unref(formData).financialInstiutionType,
                _unref(financialInstiutionTypes)
              ).value
            
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.branchName'),
          prop: "branchName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).branchName,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formData).branchName) = $event)),
              disabled: _unref(disabled)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.branchCode'),
          prop: "branchCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).branchCode,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(formData).branchCode) = $event)),
              disabled: _unref(disabled)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.accountNumber'),
          prop: "accountNumber"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).accountNumber,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(formData).accountNumber) = $event)),
              disabled: _unref(disabled)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.depositType'),
          prop: "depositType",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).depositType,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formData).depositType) = $event)),
              disabled: _unref(disabled)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depositTypesSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.accountHolderFullWidth'),
            prop: "accountHolderFullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).accountHolderFullWidth,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(formData).accountHolderFullWidth) = $event)),
                disabled: _unref(disabled)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.accountHolderFullWidthKatakana'),
            prop: "accountHolderFullWidthKatakana"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).accountHolderFullWidthKatakana,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(formData).accountHolderFullWidthKatakana) = $event)),
                disabled: _unref(disabled)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ])
    ])
  ], 64))
}
}

})